import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

interface FilterButtonArrayProps {
  viewMode: string;
  handleViewModeChange: (event) => void;
}

const FilterButtonArray = ({
  viewMode,
  handleViewModeChange,
}: FilterButtonArrayProps) => {
  function handleViewChange(
    _event: React.MouseEvent<HTMLElement>,
    newViewMode: string | null
  ) {
    if (newViewMode !== null) {
      handleViewModeChange(newViewMode);
    }
  }

  return (
    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={handleViewChange}
      aria-label="text alignment"
    >
      <ToggleButton value="list-view" aria-label="List view" size="small">
        <ViewListOutlinedIcon />
      </ToggleButton>
      <ToggleButton value="map-view" aria-label="Map view" size="small">
        <MapOutlinedIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default FilterButtonArray;
